<template>
  <div
    class="modal"
    style="display:block"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="row">
            <div class="col-sm-12">
              <span v-if="mode === modalWindowTypes.CREATE">Add new integration</span>
              <span v-if="mode === modalWindowTypes.EDIT">Edit integration</span>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <select
                  v-model="models.data.id"
                  class="form-control"
                >
                  <option
                    v-for="(detail, index) of details"
                    :key="`${detail.name}_${index}`"
                    :value="detail.id"
                  >
                    {{ detail.name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <select
                  v-model="models.data.actionId"
                  class="form-control"
                >
                  <option
                    v-for="(action, index) of detailActions"
                    :key="index"
                    :value="action.id"
                  >
                    {{ action.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            v-if="mode === modalWindowTypes.CREATE"
            class="btn btn-success"
            @click="add()"
          >
            Add
          </button>
          <button
            v-if="mode === modalWindowTypes.EDIT"
            class="btn btn-success"
            @click="save()"
          >
            Save
          </button>
          <button
            class="btn btn-danger"
            @click="close()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  modalWindowTypes
} from '@/utils/dictionaries'

export default {
  name: 'ModalIntegration',
  props: {
    model: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: modalWindowTypes.CREATE
    }
  },
  data: () => (
    {
      details: [
        {
          id: 1,
          name: 'Google Sheets',
          iconName: 'google-sheets',
          lineColor: '#289250',
          actions: [
            {
              id: 1,
              name: 'add_row',
              label: 'Add a Row'
            },
            {
              id: 2,
              name: 'remove_row',
              label: 'Remove a Row'
            }
          ]
        },
        {
          id: 2,
          name: 'Google Word',
          iconName: 'google-docs',
          lineColor: '#3a6fe9',
          actions: [
            {
              id: 1,
              name: 'add_row',
              label: 'Add a Word'
            },
            {
              id: 2,
              name: 'remove_row',
              label: 'Remove a Word'
            }
          ]
        }
      ],
      models: {
        data: {
          id: 1,
          actionId: 1
        },
        icon: {
          name: '',
          line: ''
        },
        text: ''
      }
    }
  ),
  computed: {
    modalWindowTypes() {
      return modalWindowTypes
    },
    detailActions() {
      let detail = this.details.find(e => e.id === this.models.data.id)
      return detail ? detail.actions : []
    }
  },
  mounted() {
    if (this.model !== null) {
      this.updateData()
    }
  },
  methods: {
    add() {
      this.setTextAndIcon()
      this.$emit('add', { ...this.$data.models })
    },
    save() {
      this.setTextAndIcon()
      this.$emit('save', { ...this.$data.models })
    },
    close() {
      this.$emit('close')
    },
    updateData() {
      this.models.data.id = this.model.value.id
      this.models.data.actionId = this.model.value.actionId
    },
    setTextAndIcon() {
      const detail = this.details.find(d => d.id === this.models.data.id)
      const action = detail.actions.find(a => a.id === this.models.data.actionId)

      this.models.icon.name = detail.iconName
      this.models.icon.line = detail.lineColor

      this.models.text = `${action.label} in ${detail.name}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ModalIntegration.vue